import { render, staticRenderFns } from "./PageDocStockAide.vue?vue&type=template&id=3b307fa3&"
import script from "./PageDocStockAide.vue?vue&type=script&lang=js&"
export * from "./PageDocStockAide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports